import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Ventures from "@/components/Ventures";
import Bento from "@/components/Bento";
import IRBand from "@/components/IRBand";
import GlobalPresence from "@/components/GlobalPresence";
import RoboticsTeaser from "@/components/RoboticsTeaser";
import CTABand from "@/components/CTABand";

const Home = () => (
  <div data-testid="page-home">
    <Hero />
    <Marquee />
    <Stats />
    <Ventures />
    <Bento />
    <IRBand />
    <GlobalPresence />
    <RoboticsTeaser />
    <CTABand />
  </div>
);

export default Home;
